<template>
  <div class="price notranslate">
    <span class="now-price" :class="[priceInfo.sell_price !== priceInfo.price ? 'sale' : '']"
      >{{ currency.symbol_prefix }}{{ priceInfo.sell_price }}{{ currency.symbol_suffix }}</span
    >
    <span v-if="computedShowUnderlinePrice" class="old-price"
      >{{ currency.symbol_prefix }}{{ priceInfo.price }}{{ currency.symbol_suffix }}</span
    >
  </div>
</template>

<script setup lang="ts">
import type { IPriceAmount } from '@/api/types/currency-price';
import type { ProductsListItem } from '@/api/types/product';
import { genPrice } from '@/assets/js/currency-price';
import { useStore } from '@/store';

interface Props {
  product: Partial<ProductsListItem>;
  showUnderlinePrice?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  product: () => ({}) as ProductsListItem,
  showUnderlinePrice: true,
});

const store = useStore();
const currency = computed(() => store.currency);

const priceInfo = computed<IPriceAmount>(() => {
  try {
    if (props.product && props.product.display_price_info) {
      return genPrice(props.product.display_price_info, currency.value.name);
    }
  } catch (error) {
    console.log(error);
  }
  return {
    sell_price: '',
    price: '',
  };
});

const computedShowUnderlinePrice = computed<boolean>(() => {
  return props.showUnderlinePrice && priceInfo.value.sell_price !== priceInfo.value.price;
});
</script>

<style scoped lang="scss">
.now-price {
  color: $c-r;
}
.old-price {
  text-decoration: line-through;
  color: $c-grey_l;
}
</style>
